"use strict";
import { USERINFOKEY } from "./const";
import api from "@/axios/interface";
import store from "../store";

/**
 * Base64 解加密
 *
 * @param  { String } stringToEncode/encodedData
 * @return { String } encodedData/stringDecode
 * **/
export const Base64_encode = stringToEncode => {
	const encodeUTF8string = function(str) {
		return encodeURIComponent(str).replace(
			/%([0-9A-F]{2})/g,
			function toSolidBytes(match, p1) {
				return String.fromCharCode("0x" + p1);
			}
		);
	};

	if (typeof window !== "undefined") {
		if (typeof window.btoa !== "undefined") {
			window.btoa(encodeUTF8string(stringToEncode));
		}
	} else {
		return new Buffer(stringToEncode).toString("base64");
	}
	const b64 =
		"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	let o1,
		o2,
		o3,
		h1,
		h2,
		h3,
		h4,
		bits,
		i = 0,
		ac = 0,
		enc = "",
		tmpArr = [];
	if (!stringToEncode) {
		return stringToEncode;
	}
	stringToEncode = encodeUTF8string(stringToEncode);
	do {
		o1 = stringToEncode.charCodeAt(i++);
		o2 = stringToEncode.charCodeAt(i++);
		o3 = stringToEncode.charCodeAt(i++);
		bits = (o1 << 16) | (o2 << 8) | o3;
		h1 = (bits >> 18) & 0x3f;
		h2 = (bits >> 12) & 0x3f;
		h3 = (bits >> 6) & 0x3f;
		h4 = bits & 0x3f;
		tmpArr[ac++] =
			b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
	} while (i < stringToEncode.length);
	enc = tmpArr.join("");
	const r = stringToEncode.length % 3;
	return (r ? enc.slice(0, r - 3) : enc) + "===".slice(r || 3);
};

export const Base64_decode = encodedData => {
	const decodeUTF8string = function(str) {
		return decodeURIComponent(
			str
				.split("")
				.map(function(c) {
					return (
						"%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
					);
				})
				.join("")
		);
	};

	if (typeof window !== "undefined") {
		if (typeof window.atob !== "undefined") {
			return decodeUTF8string(window.atob(encodedData));
		}
	} else {
		return new Buffer(encodedData, "base64").toString("utf-8");
	}
	const b64 =
		"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	let o1,
		o2,
		o3,
		h1,
		h2,
		h3,
		h4,
		bits,
		i = 0,
		ac = 0,
		dec = "",
		tmpArr = [];
	if (!encodedData) {
		return encodedData;
	}
	encodedData += "";
	do {
		// unpack four hexets into three octets using index points in b64
		h1 = b64.indexOf(encodedData.charAt(i++));
		h2 = b64.indexOf(encodedData.charAt(i++));
		h3 = b64.indexOf(encodedData.charAt(i++));
		h4 = b64.indexOf(encodedData.charAt(i++));
		bits = (h1 << 18) | (h2 << 12) | (h3 << 6) | h4;
		o1 = (bits >> 16) & 0xff;
		o2 = (bits >> 8) & 0xff;
		o3 = bits & 0xff;
		if (h3 === 64) {
			tmpArr[ac++] = String.fromCharCode(o1);
		} else if (h4 === 64) {
			tmpArr[ac++] = String.fromCharCode(o1, o2);
		} else {
			tmpArr[ac++] = String.fromCharCode(o1, o2, o3);
		}
	} while (i < encodedData.length);
	dec = tmpArr.join("");
	return decodeUTF8string(dec.replace(/\0+$/, ""));
};

/**
 * 判断为空
 * **/

/**
 * 变量
 *
 * @param  { var } key
 * @return { Boolean }
 * **/
export const isEmpty = key =>
	!key || typeof key === "undefined" || key === null;

/**
 * 数组
 *
 * @param  { Array<Object> } arr
 * @return { Boolean }
 * **/
export const isEmptyArray = arr => !arr.length;

/**
 * 对象
 *
 * @param  { Object } obj
 * @return { Boolean }
 * **/
export const isEmptyObject = obj => {
	if (typeof obj === "object" && !(obj instanceof Array) && obj !== null) {
		for (let t in obj) return !1;
		return !0;
	}
};

/**
 * 路由
 * **/

/**
 * 将参数部分（search）转为对象
 *
 * @return { * }
 * **/
export const getUrlParam = s => {
	let urlParamObj = {},
		search = s || location.search;

	if (search.indexOf("?") > -1) {
		search = search.substr(1);
		const searchArr = search.split("&");

		for (let i = 0, len = searchArr.length; i < len; i++) {
			urlParamObj[searchArr[i].split("=")[0]] = searchArr[i].split(
				"="
			)[1];
		}
	}

	return urlParamObj;
};

/** 用户信息
 *
 * 获取userInfo
 **/
export const getUserInfo = () => {
	// 采用Base64加密
	const userInfo =
		sessionStorage.getItem(USERINFOKEY) ||
		localStorage.getItem(USERINFOKEY);
	try {
		return JSON.parse(Base64_decode(userInfo));
	} catch (e) {
		return !isEmpty(userInfo) ? JSON.parse(userInfo) : null;
	}
};

// localStorage 保存 userInfo
export const saveUserInfo = v => {
	if (!v) {
		return;
	}
	v.autoLogin
		? localStorage.setItem(USERINFOKEY, Base64_encode(JSON.stringify(v)))
		: sessionStorage.setItem(USERINFOKEY, Base64_encode(JSON.stringify(v)));
};

// localStorage 保存 userInfo
export const removeUserInfo = () => {
	localStorage.removeItem(USERINFOKEY);
};

// 是否登录
export const isLogin = () => {
	const userInfo = getUserInfo();
	return !isEmpty(userInfo) && userInfo.hasOwnProperty("token");
};

/**
 * 计算数字
 *
 * **/

/** 对比数字
 *@param {string} cVersion 需要对比的版本号
 *@param {string} bVersion 版本号界线
 * return {number} 小于返回-1;等于返回0;大于返回1
 * **/
export const getVersionCompared = (cVersion, bVersion) => {
	const cVersionArr = cVersion.split("."),
		bVersionArr = bVersion.split(".");
	const length = Math.max(cVersionArr.length, bVersionArr.length);
	for (let i = 0; i < length; i++) {
		if (typeof cVersionArr[i] === "undefined") cVersionArr.push("0");
		if (typeof bVersionArr[i] === "undefined") bVersionArr.push("0");
		if (Number(cVersionArr[i]) < Number(bVersionArr[i])) {
			return -1;
		} else if (Number(cVersionArr[i]) > Number(bVersionArr[i])) {
			return 1;
		}
	}
	return 0;
};

/**
 * 四舍五入
 *
 * @param { Number } number
 * @param { Number } digit
 * **/
export const getMathRound = (number = 0, digit = 2) => {
	const exponent = Math.pow(10, digit);
	return Math.round(number * exponent) / exponent;
};

/**
 * 浏览器 browser
 * 内核 kernel & 版本 version
 *
 * @return {*}  kernel, version
 * **/
export const getBrowser = () => {
	let s,
		kernel = "",
		version = "",
		ua = navigator.userAgent.toLowerCase();

	//探测浏览器
	(s = ua.match(/msie ([\d.]+)/))
		? _set("ie", _toFixedVersion(s[1]))
		: (s = ua.match(/firefox\/([\d.]+)/))
		? _set("firefox", _toFixedVersion(s[1]))
		: (s = ua.match(/chrome\/([\d.]+)/))
		? _set("chrome", _toFixedVersion(s[1]))
		: (s = ua.match(/opera.([\d.]+)/))
		? _set("opera", _toFixedVersion(s[1]))
		: (s = ua.match(/version\/([\d.]+).*safari/))
		? _set("safari", _toFixedVersion(s[1]))
		: 0;

	function _toFixedVersion(ver, floatLength) {
		ver = ("" + ver).replace(/_/g, ".");
		floatLength = floatLength || 1;
		ver = String(ver).split(".");
		ver = ver[0] + "." + (ver[1] || "0");
		ver = Number(ver).toFixed(floatLength);
		return ver;
	}

	function _set(k, v) {
		kernel = k;
		version = v;
	}

	return {
		kernel,
		version
	};
};

/**
 * 正则替换/匹配
 * **/

/**
 * 移除所有空格
 *
 * */
export const removeAllSpace = v => v.replace(/\s+/g, "");

// 移除所有超链接
export const removeAllHyperLink = html => {
	const reg = new RegExp(/<a[^>]*href=['"]([^"]*)['"].*?[^>]*>(.*?)<\/a>/gi);
	return reg.test(html) ? html.replace(reg, "") : html;
};

// 替换所有超链接为文本
export const replaceAllHyperLinkToText = html => {
	const reg = new RegExp(/<a[^>]*href=['"]([^"]*)['"].*?[^>]*>(.*?)<\/a>/gi);
	const regAnchoStart = new RegExp(/<a[^>]*href=['"]([^"]*)['"].*?[^>]*>/gi);
	const regAnchoEnd = new RegExp(/<\/a>/gi);
	return reg.test(html)
		? html.replace(regAnchoStart, "").replace(regAnchoEnd, "")
		: html;
};

/**
 * 检测空白行
 *
 * 匹配任意空或空白字符，如果你什么也没输入，或输入的只有空格、回车、换行等字符，则匹配成功
 */
export const isBlank = str => {
	const reg = /^\s*$/;
	return reg.test(str);
};

/**
 * 验证URL地址
 *
 * **/
export const checkUrl = url => {
	const re = new RegExp(
		"(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/"
	);
	return re.test(url);
};

/**
 * 清除 字符 前后空格
 *
 * @param  { String } str
 * @return { String }
 * **/
export const clearSpace = str => str.replace(/(^\s*)|(\s*)$/g, "");

